<script lang="ts">
	import { HEIGHT, WIDTH } from '../utils/constants';

	export let isSymmetrical = false;
	export let color = 'black';
</script>

{#if isSymmetrical}
	<div
		style="left:0px;
		       top:{(HEIGHT * 50) / 2}px;
			   width:{WIDTH * 50}px;
			   position: absolute;
			   overflow:hidden;
			  "
	>
		<div class=" bar" style="background-color:{color}" />
		<div class="lightning bar" style="background-color:{color}" />
	</div>
{/if}

<style>
	.bar {
		height: 4px;
		width: 200px;
		background-color: red;
		z-index: 1000;
		animation-name: glance;
		animation-duration: 400ms;
		animation-fill-mode: forwards;
	}

	@keyframes glance {
		from {
			transform: translateX(-300px);
			opacity: 1;
		}
		to {
			transform: translateX(400px);
			opacity: 1;
		}
	}
	.lightning {
		filter: blur(16px);
	}
</style>
